import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import ApiClient from "../../api-client";
import { apiUrl, PORT } from "../../environment";
import { toasterConfig } from "../../utils/constants";

toast.configure();


export const getAssetAnalyzer = (params,callback) => {
  return (dispatch, getState) => {
  const { user: { token } } = getState();
  ApiClient.get(`${apiUrl}${PORT}/analyzer`, params,token, dispatch).then((response) => {
    if (response) {
      console.log('response',response)
      dispatch({ type: "ASSET_ANALYZER", data: response });
      return callback(response);
    }else if (response.messageID === 404) {
      toast.error(response.message);
      return callback();
    } else {
      toast.error(response.errors.msg)
    }
  });
}
};


export const getAnalyzerTypesListing = (callback) => {
  return (dispatch, getState) => {
    const { user: { token } } = getState();
    ApiClient.get(`${apiUrl}${PORT}/analyzerType/analyzerTypeListing`, {},token, dispatch).then((response) => {
      if (response) {
        return callback(response);
      }else if (response.messageID === 404) {
        toast.error(response.message);
        return callback();
      } else {
        toast.error(response.errors.msg);
        return callback();
      }
    });
  }
};


/**
 * @description function use for to get folder elastic incomeanalyzer 
 * @param {*} params accepting object (loan_number)
 */

 export const getElasticSearchAnalyzer = (params, callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    ApiClient.get(`${apiUrl}${PORT}/analyzer/search`, params, token, dispatch).then(
      (response) => {
        if (response && !response.errors) {

          return callback(response);
        } else if (response.code === 404) {
          toast.error(response.message);
        } else {
          toast.error(response.errors.msg, toasterConfig);
        }
      }
    );
  };
};



export const getAnalyzerOutput = (analyzerId,callback) => {
  return (dispatch, getState) => {
  const { user: { token } } = getState();
  ApiClient.get(`${apiUrl}${PORT}/analyzer/${analyzerId}/getAnalyzerOutput`, {},token, dispatch).then((response) => {
    if (response) {
      console.log('response',response)
     // dispatch({ type: "INCOME_ANALYZER", data: response });
      return callback(response);
    }else if (response.messageID === 404) {
      toast.error(response.message);
      return callback();
    } else {
      toast.error(response.errors.msg)
    }
  });
}
};

export const mergeIncomeAnalyzer = (params,callback) => {
  return (dispatch, getState) => {
  const { user: { token } } = getState();
  ApiClient.get(`${apiUrl}${PORT}/irsIncome`, params,token, dispatch).then((response) => {
    if (response) {
      console.log('response',response)
      dispatch({ type: "MERGE_INCOME_ANALYZER", data: response });
      return callback(response);
    }else if (response.messageID === 404) {
      toast.error(response.message);
      return callback();
    } else {
      toast.error(response.errors.msg)
    }
  });
}
};

export const resetIncomeAnalyzer = () => {
  return (dispatch, getState) => {
    dispatch({ type: "RESET_INCOME_ANALYZER", data: {} });
  }
};




export const getAnalyzerAllPdf = (analyzerId,callback) => {
  return (dispatch, getState) => {
  const { user: { token } } = getState();
  ApiClient.get(`${apiUrl}${PORT}/analyzer/${analyzerId}/getAnalyzerAllPdf`, {},token, dispatch).then((response) => {
    if (response) {
      console.log('response',response)
     // dispatch({ type: "INCOME_ANALYZER", data: response });
      return callback(response);
    }else if (response.messageID === 404) {
      toast.error(response.message);
      return callback();
    } else {
      toast.error(response.errors.msg)
    }
  });
}
};

export const getAnalyzerDetail = (analyzerId,callback) => {
  return (dispatch, getState) => {
  const { user: { token } } = getState();
  ApiClient.get(`${apiUrl}${PORT}/analyzer/${analyzerId}/getAnalyzerDetail`, {},token, dispatch).then((response) => {
    if (response) {
      console.log('response',response)
     // dispatch({ type: "INCOME_ANALYZER", data: response });
      return callback(response);
    }else if (response.messageID === 404) {
      toast.error(response.message);
      return callback();
    } else {
      toast.error(response.errors.msg)
    }
  });
}
};



export const getAnalyzerValidationDetail = (analyzerId,callback) => {
  return (dispatch, getState) => {
  const { user: { token } } = getState();
  ApiClient.get(`${apiUrl}${PORT}/analyzer/${analyzerId}/getAnalyzerValidationDetail`, {},token, dispatch).then((response) => {
   
    return callback({
      "analyzerId": "987f6543-ab12-34cd-56ef-789012345678",
      "type": "asset",
      "loanNumber": "230259986",
      "borrowerId": "33b0f409-d366-49db-bad4-dab0cd85e463",
      "executionDate": "2025-11-19T01:31:00.000Z",
      "documents": [
          {
              "documentId": "435bae26-cb19-489a-be22-fc445089e22a",
              "displayName": "Chase Checking Bank Statement - August 2025",
              "receivedDate": "2025-11-12T12:35:20.235Z",
              "errorCount": 0,
              "warningCount": 1,
              "dateRange": {
                  "startDate": "2025-08-01",
                  "endDate": "2025-08-31"
              },
              "validationIssues": [
                  {
                      "code": "BANK_STATEMENT_MISSING_PAGES",
                      "scope": "Document",
                      "level": "Warning",
                      "blocksAnalysis": false,
                      "isUserOverridable": true,
                      "isOverridden": false,
                      "title": "Missing Pages Detected",
                      "message": "Expected 12 pages but received 10 pages. Pages 5–6 appear to be missing.",
                      "insight": "Provide missing pages or accept this issue."
                  },
                  {
                      "code": "UNSUPPORTED_ACCOUNT_TYPE",
                      "scope": "Account",
                      "level": "Info",
                      "blocksAnalysis": false,
                      "isUserOverridable": false,
                      "isOverridden": false,
                      "title": "Unsupported Account Type",
                      "message": "The savings account ending in 9876 is not supported for asset calculations.",
                      "insight": "This account was excluded from totals."
                  }
              ],
              "accounts": [
                  {
                      "accountId": "acc_001",
                      "bankName": "Chase",
                      "accountType": "Checking",
                      "accountNumber": "1234",
                      "summary": {
                          "beginningBalance": 3200.45,
                          "endingBalance": 4100.22,
                          "totalDeposits": 6500.00,
                          "totalWithdrawals": 5600.23
                      },
                      "largeDeposits": [
                          {
                              "analyzerRequestId": "ar_123e4567-e89b-12d3-a456-426614174000",
                              "date": "2025-08-03",
                              "description": "DIRECT DEPOSIT PAYROLL",
                              "amount": 4250.00
                          }
                      ]
                  },
                  {
                      "accountId": "acc_002",
                      "bankName": "Chase",
                      "accountType": "Savings",
                      "accountNumber": "9876",
                      "summary": {
                          "beginningBalance": 3200.45,
                          "endingBalance": 4100.22,
                          "totalDeposits": 6500.00,
                          "totalWithdrawals": 5600.23
                      },
                      "largeDeposits": [
                          {
                              "analyzerRequestId": "ar_123e4567-e89b-12d3-a456-426614174000",
                              "date": "2025-08-15",
                              "description": "TRANSFER FROM SAVINGS",
                              "amount": 3000.00
                          }
                      ]
                  }
              ]
          }
      ],
      "analyzerSummary": {
          "overallStatus": "Ready for Analysis",
          "errorCount": 0,
          "warningCount": 1,
          "validationIssues": []
      }
  });
   
    if (response) {
      console.log('response',response)
     // dispatch({ type: "INCOME_ANALYZER", data: response });
      return callback(response);
    }else if (response.messageID === 404) {
      toast.error(response.message);
      return callback();
    } else {
      toast.error(response.errors.msg)
    }
  });
}
};




export const getIncomeAnalyzerCalculationSheet = (irsIncomeId,callback) => {
  return (dispatch, getState) => {
  const { user: { token } } = getState();
  ApiClient.get(`${apiUrl}${PORT}/irsIncome/${irsIncomeId}/getIncomeAnalyzerCalculationSheet`, {},token, dispatch).then((response) => {
    if (response) {
      console.log('response',response)
     // dispatch({ type: "INCOME_ANALYZER", data: response });
      return callback(response);
    }else if (response.messageID === 404) {
      toast.error(response.message);
      return callback();
    } else {
      toast.error(response.errors.msg)
    }
  });
}
};

export const getTaxFormsListing = (callback) => {
  return (dispatch, getState) => {
    const { user: { token } } = getState();
    ApiClient.get(`${apiUrl}${PORT}/irsIncome/taxFormsListing`, {},token, dispatch).then((response) => {
      if (response) {
        return callback(response);
      }else if (response.messageID === 404) {
        toast.error(response.message);
        return callback();
      } else {
        toast.error(response.errors.msg);
        return callback();
      }
    });
  }
};

export const getIncomeStatus = (irsIncomeId, callback) => {
  return (dispatch, getState) => {
    const { user: { token } } = getState();
    ApiClient.post(`${apiUrl}${PORT}/irsIncome/${irsIncomeId}/getIncomeStatus`, {}, token, dispatch).then((response) => {
      if (response) {
        return callback(response);
      }else if (response.messageID === 404) {
        toast.error(response.message);
        return callback();
      } else {
        toast.error(response.errors.msg);
        return callback();
      }
    });
  }
};


export const getIncomeDocList = (irsIncomeId, callback) => {
  return (dispatch, getState) => {
    const { user: { token } } = getState();
    ApiClient.post(`${apiUrl}${PORT}/irsIncome/${irsIncomeId}/getIncomeDocList`, {}, token, dispatch).then((response) => {
      if (response) {
        return callback(response);
      }else if (response.messageID === 404) {
        toast.error(response.message);
        return callback();
      } else {
        toast.error(response.errors.msg);
        return callback();
      }
    });
  }
};


export const getAnalyzerDocList = (analyzerId, callback) => {
  return (dispatch, getState) => {
    const { user: { token } } = getState();
    ApiClient.post(`${apiUrl}${PORT}/analyzer/${analyzerId}/getAnalyzerDocList`, {}, token, dispatch).then((response) => {
      if (response) {
        return callback(response);
      }else if (response.messageID === 404) {
        toast.error(response.message);
        return callback();
      } else {
        toast.error(response.errors.msg);
        return callback();
      }
    });
  }
};




export const sendAnalyzerOutputToLoans = (analyzerId, data, callback) => {
  return (dispatch, getState) => {
    dispatch({ type: "ISLOADING", data: true });
    const { user: { token } } = getState();
    ApiClient.post(`${apiUrl}${PORT}/analyzer/${analyzerId}/sendAnalyzerOutputToLoans`, data, token, dispatch).then((response) => {
      dispatch({ type: "ISLOADING", data: false });
      if (response) {
        return callback(response);
      }else if (response.messageID === 404) {
        toast.error(response.message);
        return callback();
      } else {
        toast.error(response.errors.msg);
        return callback();
      }
    });
  }
};


export const analyzerLogListing = (analyzerId, data, callback) => {
  return (dispatch, getState) => {
    dispatch({ type: "ISLOADING", data: true });
    const { user: { token } } = getState();
    console.log('icnome log listing dispatch hitting ...')
    ApiClient.post(`${apiUrl}${PORT}/analyzer/${analyzerId}/analyzerLogs`, data, token, dispatch).then((response) => {
      dispatch({type: "INCOME_LOGS_LISTING", data: response});
      dispatch({ type: "ISLOADING", data: false });
      if (response) {
        return callback(response);
      }else if (response.messageID === 404) {
        toast.error(response.message);
        return callback();
      } else {
        toast.error(response.errors.msg);
        return callback();
      }
    });
  }
};

export const saveUnableToAnalysisAnalyzerJsonData = (analyzerId, data, callback) => {
  return (dispatch, getState) => {
    const { user: { token } } = getState();
      ApiClient.post(`${apiUrl}${PORT}/analyzer/${analyzerId}/saveUnableToAnalysisAnalyzerJson`, data, token, dispatch).then((response) => { 
        dispatch({ type: "ISLOADING", data: false });
        if (response && response.success == true) {
     
           toast.success(response.msg, toasterConfig);
          callback(response);
        }
          else if (response && response.success == false){
            toast.error(response.msg, toasterConfig);
            callback(response);
          }
         else {
          toast.error(response.errors.msg, toasterConfig);
          return callback();
        }
      });
  }
};




export const updateCompleteStatus = (data, callback) => {
  return (dispatch, getState) => {
    dispatch({ type: "ISLOADING", data: true });
    const { user: { token } } = getState();
      ApiClient.post(`${apiUrl}${PORT}/analyzer/updateCompleteStatus`, data, token, dispatch).then((response) => { 
        dispatch({ type: "ISLOADING", data: false });
        if (response) {

          callback(response);
        }
          else if (response && response.success == false){
            toast.error(response.msg, toasterConfig);
            callback(response);
          }
         else {
          toast.error(response?.errors?.msg, toasterConfig);
          return callback();
        }
      });
  }
}

export const saveQAVerification = (params, callback) => {
  return (dispatch, getState) => {
    const {
      user: { token },
    } = getState();
    dispatch({ type: "ISLOADING", data:true })
    let url = `${apiUrl}${PORT}/irsIncome/saveQAVerification`
    ApiClient.post(
      url,
      params,
      token,
      dispatch
    ).then((response) => {
      dispatch({ type: "ISLOADING", data: false });
      if (response && !response.errors) {
        toast.success(response.message)
        callback(response);
      } else if (response.code === 404) {
        toast.error(response.message);
        callback()
      } else {
        toast.error(response.errors.msg, toasterConfig);
        callback()
      }
    });
  };
};

  export const getPendingIRSIncomeDetail = (loan_number,callback) => {
    return (dispatch, getState) => {
    const { user: { token } } = getState();
    ApiClient.get(`${apiUrl}${PORT}/irsIncome/getPendingIRSIncomeDetail/${loan_number}`,null,token, dispatch).then((response) => {
      if (response) {
        console.log('response',response)
       // dispatch({ type: "INCOME_ANALYZER", data: response });
        return callback(response);
      }else if (response.messageID === 404) {
        toast.error(response.message);
        return callback();
      } else {
        toast.error(response.errors.msg)
      }
    });
  }
  };